import { createSelector } from 'reselect';

import { State, PatientInfo, PatientChartInfo, ChartsState, HydratedPatientInfo } from 'types';

const _getActivePatient = (state: State): PatientInfo =>
  state.session.activeUserId && state.entities.patients
    ? state.entities.patients[state.session.activeUserId]
    : undefined;

export const getActivePatient = createSelector(
  _getActivePatient,
  state => state.entities.charts,
  (patient: PatientInfo, charts: ChartsState): HydratedPatientInfo => {
    if (patient && patient.charts && charts) {
      return {
        ...patient,
        charts: patient.charts.map(chartId => charts[chartId]).filter(chart => chart),
      };
    }

    return undefined;
  },
);

export const getActiveChart = createSelector(
  (state: State): ChartsState => state.entities.charts,
  (state: State): number => state.session.activeChartId,
  (charts, activeChartId): PatientChartInfo => {
    if (!(charts && activeChartId)) {
      return undefined;
    }

    return charts[activeChartId];
  },
);

export const getPatient = (state: State, { patientId }: { patientId: number }) =>
  state.entities.patients ? state.entities.patients[patientId] : undefined;
